import { Injectable, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { Batch } from '../models/registration.model';

@Injectable({
  providedIn: 'root',
})
export class RegistrationCommentService {
  private readonly locale = inject(LocaleService);

  buildMandatoryComment(batches: Pick<Batch, 'isPool' | 'isDayPriceStorage'>[]): string {
    const labels: string[] = [];
    if (batches.some((b) => b.isPool)) {
      labels.push(this.locale.translate('complete.pool-mandatory-comment'));
    }
    if (batches.some((b) => !b.isPool && !b.isDayPriceStorage)) {
      labels.push(this.locale.translate('complete.dayprice-direct-mandatory-comment'));
    }
    if (batches.some((b) => !b.isPool && b.isDayPriceStorage)) {
      labels.push(this.locale.translate('complete.dayprice-storage-mandatory-comment'));
    }
    return labels.join(' ');
  }
}
